<!-- LOADING -->
<app-loading [hidden]="!loading"></app-loading>

<!-- CONTEÚDO -->
<div *ngIf="!loading" class="flex flex-col h-full">

    <!-- FILTROS -->
    <div class="flex flex-col gap-4 mb-6">
        <!-- Filtros de data -->
        <div class="w-full">
            <!-- Datas + Filtrar/Limpar: em mobile empilhado, lg na mesma linha -->
            <div class="flex flex-col lg:flex-row lg:items-center gap-3 lg:gap-4">
                <!-- Datas: em mobile 1 col, sm+ 2 cols -->
                <div class="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4">
                    <div class="flex items-center gap-2">
                        <label for="initialDate" class="text-sm font-medium text-westetics-neutral-700 whitespace-nowrap">De:</label>
                        <input 
                            type="date" 
                            id="initialDate" 
                            [(ngModel)]="initialDate" 
                            class="bg-white border border-gray-300 rounded-lg px-3 py-2.5 text-sm focus:ring-2 focus:ring-westetics-purple-500 focus:border-transparent w-full"
                        />
                    </div>
                    <div class="flex items-center gap-2">
                        <label for="finalDate" class="text-sm font-medium text-westetics-neutral-700 whitespace-nowrap">Até:</label>
                        <input 
                            type="date" 
                            id="finalDate" 
                            [(ngModel)]="finalDate" 
                            class="bg-white border border-gray-300 rounded-lg px-3 py-2.5 text-sm focus:ring-2 focus:ring-westetics-purple-500 focus:border-transparent w-full"
                        />
                    </div>
                </div>
                <!-- Botões Filtrar/Limpar -->
                <div class="flex flex-col sm:flex-row gap-2 sm:justify-center sm:items-center lg:justify-start">
                    <button 
                        (click)="onDateChange()"
                        class="py-2 px-4 rounded-lg font-medium text-sm bg-westetics-purple-800 text-white hover:bg-westetics-purple-700 transition-colors w-full sm:w-48 lg:w-auto"
                    >
                        Filtrar
                    </button>
                    <button 
                        *ngIf="initialDate || finalDate" 
                        (click)="clearDateFilters()"
                        class="py-2 px-4 rounded-lg font-medium text-sm border border-westetics-purple-800 text-westetics-purple-800 hover:bg-westetics-purple-800 hover:text-white transition-colors w-full sm:w-32 lg:w-auto"
                    >
                        Limpar
                    </button>
                </div>
            </div>
        </div>

        <!-- Botões de filtro por status -->
        <div class="flex flex-wrap gap-2 justify-center sm:justify-start">
            <button 
                (click)="changeFilter('ACTIVE')"
                class="py-2 px-4 rounded-lg font-medium text-sm transition-colors"
                [ngClass]="{
                    'bg-westetics-purple-800 text-white': filterType === 'ACTIVE',
                    'text-westetics-purple-800 hover:text-white border-westetics-purple-800 hover:bg-westetics-purple-800 border': filterType !== 'ACTIVE'
                }"
            >
                Ativos
            </button>
            <button 
                (click)="changeFilter('CLOSED')"
                class="py-2 px-4 rounded-lg font-medium text-sm transition-colors"
                [ngClass]="{
                    'bg-westetics-purple-800 text-white': filterType === 'CLOSED',
                    'text-westetics-purple-800 hover:text-white border-westetics-purple-800 hover:bg-westetics-purple-800 border': filterType !== 'CLOSED'
                }"
            >
                Finalizados
            </button>
            <button 
                (click)="changeFilter('ALL')"
                class="py-2 px-4 rounded-lg font-medium text-sm transition-colors"
                [ngClass]="{
                    'bg-westetics-purple-800 text-white': filterType === 'ALL',
                    'text-westetics-purple-800 hover:text-white border-westetics-purple-800 hover:bg-westetics-purple-800 border': filterType !== 'ALL'
                }"
            >
                Todos
            </button>
        </div>
    </div>

    <!-- TABELA DESKTOP -->
    <div class="hidden md:block relative overflow-x-auto rounded-lg flex-1">
        <table class="w-full text-sm text-left text-gray-500 mb-8">
            <thead class="px-2 text-xs text-white bg-westetics-purple-300 mb-2">
                <tr class="text-left">
                    <th scope="col" class="px-5 py-2 font-medium text-nowrap text-sm">
                        Data de Criação
                    </th>
                    <th scope="col" class="px-5 py-2 font-medium text-nowrap text-sm">
                        Paciente
                    </th>
                    <th scope="col" class="px-5 py-2 font-medium text-nowrap text-sm">
                        Profissional
                    </th>
                    <th scope="col" class="px-5 py-2 font-medium text-nowrap text-sm">
                        Procedimentos
                    </th>
                    <th scope="col" class="px-5 py-2 font-medium text-nowrap text-sm">
                        Valor Total
                    </th>
                    <th *ngIf="filterType === 'ALL'" scope="col" class="px-5 py-2 font-medium text-nowrap text-sm">
                        Status
                    </th>
                    <th scope="col" class="px-5 py-2 font-medium text-nowrap text-sm">
                        Ações
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr 
                    *ngFor="let plan of treatmentPlans" 
                    class="border-b hover:bg-gray-50 cursor-pointer" 
                    (click)="viewTreatmentPlan(plan.id)"
                >
                    <td class="p-4 text-sm text-westetics-neutral-950">
                        {{ formatDate(plan.created_at) }}
                    </td>
                    <td class="p-4 text-sm text-westetics-neutral-950">
                        {{ plan.patient_name || '-' }}
                    </td>
                    <td class="p-4 text-sm text-westetics-neutral-950">
                        {{ plan.responsible_professional || '-' }}
                    </td>
                    <td class="p-4 text-sm text-westetics-neutral-950">
                        {{ plan.contracted_procedures || '-' }}
                    </td>
                    <td class="p-4 text-sm text-westetics-neutral-950">
                        {{ formatCurrency(plan.total_value) }}
                    </td>
                    <td *ngIf="filterType === 'ALL'" class="p-4 text-sm">
                        <span class="flex items-center gap-2" [ngClass]="getStatusClass(plan.status)">
                            <fa-icon [icon]="faCircle" class="text-[8px]"></fa-icon>
                            {{ getStatusText(plan.status) }}
                        </span>
                    </td>
                    <td class="p-4 text-sm text-westetics-neutral-950">
                        <div class="flex gap-3">
                            <button
                                (click)="viewTreatmentPlan(plan.id); $event.stopPropagation()"
                                class="cursor-pointer text-westetics-purple-800 hover:text-westetics-purple-600"
                                title="Visualizar"
                            >
                                <fa-icon [icon]="faEye"></fa-icon>
                            </button>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>

        <!-- Mensagem quando não há planos -->
        <div *ngIf="treatmentPlans.length === 0 && !loading" class="text-center py-8 text-westetics-neutral-600">
            Nenhum plano de tratamento encontrado.
        </div>
    </div>

    <!-- CARDS MOBILE -->
    <div class="md:hidden space-y-3 mb-6 flex-1">
        <div *ngFor="let plan of treatmentPlans" 
             class="bg-white rounded-lg border border-gray-200 p-4 hover:shadow-md transition-shadow cursor-pointer"
             (click)="viewTreatmentPlan(plan.id)">
            <div class="flex justify-between items-start mb-3">
                <div class="min-w-0 flex-1">
                    <h3 class="text-sm font-semibold text-westetics-neutral-950 truncate">{{ plan.patient_name || '-' }}</h3>
                    <p class="text-xs text-westetics-neutral-600">{{ formatDate(plan.created_at) }}</p>
                </div>
                <span *ngIf="filterType === 'ALL'" class="flex items-center gap-1 text-xs px-2 py-0.5 rounded-full" [ngClass]="getStatusClass(plan.status)">
                    <fa-icon [icon]="faCircle" class="text-[6px]"></fa-icon>
                    {{ getStatusText(plan.status) }}
                </span>
            </div>
            <div class="grid grid-cols-2 gap-2 text-xs mb-2">
                <div>
                    <span class="text-westetics-neutral-500">Profissional:</span>
                    <span class="ml-1 text-westetics-neutral-900">{{ plan.responsible_professional || '-' }}</span>
                </div>
                <div>
                    <span class="text-westetics-neutral-500">Valor:</span>
                    <span class="ml-1 text-westetics-purple-800 font-medium">{{ formatCurrency(plan.total_value) }}</span>
                </div>
            </div>
            <div class="text-xs">
                <span class="text-westetics-neutral-500">Procedimentos:</span>
                <span class="ml-1 text-westetics-neutral-900">{{ plan.contracted_procedures || '-' }}</span>
            </div>
        </div>

        <!-- Mensagem quando não há planos -->
        <div *ngIf="treatmentPlans.length === 0 && !loading" class="text-center py-8 text-westetics-neutral-600">
            Nenhum plano de tratamento encontrado.
        </div>
    </div>

    <!-- PAGINADOR -->
    <div *ngIf="treatmentPlans.length > 0" class="flex flex-col lg:flex-row items-center justify-between gap-3 py-4 px-3 lg:px-5">
        <!-- Esquerda: Mostrando X - Y de Z -->
        <div class="text-xs lg:text-sm text-westetics-neutral-800 order-3 lg:order-1">
            Mostrando {{ currentPage * pageSize + 1 }} - {{ Math.min((currentPage + 1) * pageSize, totalElements) }} de {{ totalElements }}
        </div>

        <!-- Centro: Botões de navegação -->
        <div class="flex items-center gap-1 lg:gap-2 order-1 lg:order-2">
            <button
                (click)="goToPreviousPage()"
                [disabled]="currentPage === 0"
                class="p-2 lg:px-3 lg:py-2 rounded-lg border border-gray-300 hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed min-w-[32px] lg:min-w-[36px] flex items-center justify-center"
                title="Página anterior"
            >
                <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 text-westetics-neutral-800" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
                </svg>
            </button>

            <ng-container *ngFor="let p of generatePagination(currentPage + 1, totalPages)">
                <button 
                    *ngIf="p !== '...'" 
                    (click)="navigateTo(p)"
                    class="px-2 lg:px-3 py-1.5 lg:py-2 rounded-lg text-xs lg:text-sm font-medium border min-w-[32px] lg:min-w-[36px]"
                    [ngClass]="{
                        'bg-westetics-purple-600 text-white border-westetics-purple-600': p === currentPage + 1,
                        'text-westetics-neutral-800 hover:bg-gray-100 border-gray-300': p !== currentPage + 1
                    }"
                >
                    {{ p }}
                </button>
                <span *ngIf="p === '...'" class="px-1 lg:px-2 text-xs lg:text-sm text-westetics-neutral-600">...</span>
            </ng-container>

            <button
                (click)="goToNextPage()"
                [disabled]="currentPage + 1 >= totalPages"
                class="p-2 lg:px-3 lg:py-2 rounded-lg border border-gray-300 hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed min-w-[32px] lg:min-w-[36px] flex items-center justify-center"
                title="Próxima página"
            >
                <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 text-westetics-neutral-800" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
                </svg>
            </button>
        </div>

        <!-- Direita: Seletor de itens por página -->
        <div class="flex items-center gap-2 text-xs lg:text-sm order-2 lg:order-3">
            <span class="text-westetics-neutral-800">Por página:</span>
            <select
                [value]="pageSize"
                (change)="changePageSize($event)"
                class="px-2 lg:px-3 py-2 rounded-lg border border-gray-300 text-xs lg:text-sm text-westetics-neutral-800 focus:outline-none focus:ring-2 focus:ring-westetics-purple-800"
            >
                <option *ngFor="let opt of pageSizeOptions" [value]="opt.value">{{ opt.label }}</option>
            </select>
        </div>
    </div>
</div>
